import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';

import OrderStop from './OrderStop';

export default styled(OrderStop)`
  &.order-stop {
    display: flex;
    justify-content: flex-start;

    &:hover {
      .edit-stop-btn {
        display: flex;
        ${media.lessThan('small')`
        display: none;
      `}
      }
    }
    &:first-child {
      .prev-step {
        background-color: var(--white);
      }
    }
    &:last-child {
      .step-data-wrapper {
        border: none;
        padding: ${gridSizes('M')} 0;
      }
      .next-step {
        background-color: var(--white);
      }
    }

    .order-stop {
      &__wrapper {
        line-height: 1.2;
        flex-grow: 1;
        position: relative;
        border-bottom: 1px solid var(--grey-mouse);
        padding: ${gridSizes('M')} 0 32px;
        max-width: 90%;

        ${media.lessThan('small')`
          font-size: 14px;
          padding: ${gridSizes('L')} 0;
          line-height: 1.4;
        `}

        ${media.lessThan('extraSmall')`
          padding: 20px 0;
        `}
      }
      &__date {
        color: var(--grey700);
        &:first-letter {
          text-transform: uppercase;
        }
      }
      &__name {
        margin: 0;
        font-weight: ${weights('medium')};
        font-size: 20px;
        margin: ${gridSizes('S')} 0;
        ${media.lessThan('small')`
      font-size: ${gridSizes('M')};
      margin: 6px 0;
    `}
      }
      &__address {
        color: var(--grey700);
      }
      &__load-info-wrapper {
        background: var(--white-caniche);
        border-radius: ${gridSizes('XS')};
        margin: ${gridSizes('M')} 0 0;
        padding: ${gridSizes('S')};
      }
    }
    .summary-item {
      background: #e2e8ee;
      padding: 5px 16px;
      width: 100%;
      margin-left: 0;
    }
  }
`;
